export default __webpack_public_path__ + "static/media/06-ideation-planning.eeac45bf.svg";